<button class="dp-trigger" (click)="toggle($event)" type="button"
    [class.dp-trigger--active]="abierto">
    <span class="dp-trigger__label">{{ label }}</span>
    <span class="dp-trigger__value">{{ fechaDisplay || 'Seleccionar' }}</span>
    <span class="material-icons">calendar_today</span>
</button>

<div class="dp-backdrop" *ngIf="abierto" (click)="cerrar()"></div>
<div class="dp-popup" *ngIf="abierto" [style.top.px]="pos.top" [style.left.px]="pos.left">
    <div class="dp-popup__header">
        <button class="dp-nav" (click)="mesAnterior()" type="button" aria-label="Mes anterior">
            <span class="material-icons">chevron_left</span>
        </button>
        <span class="dp-popup__mes">{{ mesLabel }}</span>
        <button class="dp-nav" (click)="mesSiguiente()" type="button" aria-label="Mes siguiente">
            <span class="material-icons">chevron_right</span>
        </button>
    </div>

    <div class="dp-dias-semana">
        <span *ngFor="let d of diasSemana">{{ d }}</span>
    </div>

    <div class="dp-grid">
        <button *ngFor="let dia of dias" class="dp-dia" type="button"
            [class.dp-dia--vacio]="!dia"
            [class.dp-dia--hoy]="dia && esHoy(dia)"
            [class.dp-dia--sel]="dia && esSeleccionado(dia)"
            [disabled]="!dia"
            (click)="dia && seleccionarDia(dia)">
            {{ dia ? dia.getDate() : '' }}
        </button>
    </div>
</div>
